// extracted by mini-css-extract-plugin
export var cancelButton = "_q6-5";
export var content = "_q6-3";
export var createButton = "_q6-6";
export var drawerContainer = "_q6-0";
export var footer = "_q6-2";
export var header = "_q6-1";
export var orderFormColumn = "_q6-4";